var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-3",attrs:{"outlined":""}},[_c('div',{staticClass:"text--secondary white px-1",staticStyle:{"left":"12px","position":"absolute","top":"-10px","font-size":"12px"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }